"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var useCounter_1 = tslib_1.__importDefault(require("./useCounter"));
exports.default = useCounter_1.default;
